import styled from 'styled-components';

export const Container = styled.div`
  width: 80%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;

  > div {
    margin-bottom: 20px;
  }

  h2 {
    text-align: center;
    margin-top: 20px;
  }

  h4 {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 10px 0;
    font-weight: 600;
  }
  

`;
